const pad = (value: number, length = 2) => value.toString().padStart(length, "0");

export function formatVirtualOmsDateTime(value: string) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return `${pad(date.getFullYear() % 100)}.${pad(date.getMonth() + 1)}.${pad(
    date.getDate()
  )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.${pad(
    date.getMilliseconds(),
    3
  )}`;
}
